import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Route } from 'react-router';
import injectSheet from 'react-jss';

import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as assetSelectors from '../../selectors/assetSelectors';
import routes from '../../helpers/ApplicationRoutes';

import ApplicationChips from '../../components/visibleInApplications/ApplicationChips';
import BucketSettings from '../bucketSettings/BucketSettings';
import Paper from '@material-ui/core/Paper';
import AddBucketAsset from '../bucketAssets/AddBucketAsset';

const BucketCover = ({
    bucket,
    isAdmin,
    applications,
    classes,
    selectedApp,
}) => {
    if (!bucket) {
        return null;
    }

    const createSurveyAssetInBucketPathname = routes.bucketAssets.getPath({
        organizationId: bucket.organizationId,
        bucketId: bucket.id,
        application: applications.survey.id,
    });

    const createMapspiceAssetInBucketPathname = routes.bucketAssets.getPath({
        organizationId: bucket.organizationId,
        bucketId: bucket.id,
        application: applications.mapspice.id,
    });

    const createChartAssetInBucketPathname = routes.bucketAssets.getPath({
        organizationId: bucket.organizationId,
        bucketId: bucket.id,
        application: applications.chart.id,
    });

    const createCurrencyAssetInBucketPathname = routes.bucketAssets.getPath({
        organizationId: bucket.organizationId,
        bucketId: bucket.id,
        application: applications.currency.id,
    });

    const createLayoutAssetInBucketPathname = routes.bucketAssets.getPath({
        organizationId: bucket.organizationId,
        bucketId: bucket.id,
        application: applications.layout.id,
    });

    // Don't show the create asset button for the "All" tab
    const shouldShowCreateButton = selectedApp !== 'all';

    return (
        <Paper elevation={1} square className={classes.wrapper}>
            <div className={classes.content}>
                <ApplicationChips bucket={bucket} selectedApp={selectedApp} />
                <div className={classes.actions}>
                    {isAdmin && <BucketSettings />}
                    {shouldShowCreateButton && (
                        <React.Fragment>
                            <Route
                                exact
                                path={createSurveyAssetInBucketPathname}
                                component={AddBucketAsset}
                            />
                            <Route
                                exact
                                path={createMapspiceAssetInBucketPathname}
                                component={AddBucketAsset}
                            />
                            <Route
                                exact
                                path={createChartAssetInBucketPathname}
                                component={AddBucketAsset}
                            />
                            <Route
                                exact
                                path={createCurrencyAssetInBucketPathname}
                                component={AddBucketAsset}
                            />
                            <Route
                                exact
                                path={createLayoutAssetInBucketPathname}
                                component={AddBucketAsset}
                            />
                        </React.Fragment>
                    )}
                </div>
            </div>
        </Paper>
    );
};

const mapStateToProps = state => ({
    bucket: bucketSelectors.getBucket(state),
    isAdmin: bucketSelectors.getIsCurrentUserAdminForCurrentBucket(state),
    applications: assetSelectors.getApplications(state),
    selectedApp: assetSelectors.getApplication(state),
});

BucketCover.propTypes = {
    bucket: PropTypes.object,
    isAdmin: PropTypes.bool,
    applications: PropTypes.object,
};

BucketCover.defaultProps = {
    bucket: undefined,
    isAdmin: false,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1,
        padding: [spacing.unit * 3, spacing.unit * 3, 0, spacing.unit * 3],
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
    },
});

export default withRouter(
    connect(mapStateToProps)(injectSheet(style)(BucketCover)),
);



// WEBPACK FOOTER //
// ./src/containers/cover/BucketCover.js